import get from "lodash/get"
import find from "lodash/find"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import { getTokenAction } from "actions-lib"
import { localStorageKey } from "constants-lib/localStorage"
import {
  GET_SERVICE_HISTORY_PENDING,
  GET_SERVICE_HISTORY_FULFILLED,
  GET_SERVICE_HISTORY_FAILED,
} from "constants-lib/actionTypes"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

const NUM_OF_DAYS = 180

function handlePending() {
  return {
    type: GET_SERVICE_HISTORY_PENDING,
  }
}

function handleFailed() {
  return {
    type: GET_SERVICE_HISTORY_FAILED,
  }
}

function handleFulfilled(payload) {
  return {
    type: GET_SERVICE_HISTORY_FULFILLED,
    payload,
  }
}
/**
 * Fetches service history and dispatches the appropriate action.
 * @param {number} numOfDays - The number of days to fetch the service history for. Defaults to NUM_OF_DAYS.
 * @returns {Function} A Redux thunk function that accepts `dispatch` and `getState` as parameters.
 */
export const getServiceHistory =
  (numOfDays = NUM_OF_DAYS) =>
  (dispatch, getState) => {
    dispatch(handlePending(GET_SERVICE_HISTORY_PENDING))

    const api = `GET_SERVICE_HISTORY`
    const apiKey = get(urls, `apiKey.USER.HISTORY_VISUALS`, ``)

    const template = URITemplate(urls.url[api])

    const state = getState()

    const lang = get(state, `siteLanguage.language`, ``)
    const userId = get(state, `userAccount.userDetails.userId`, ``)

    if (!userId) {
      handleFailed()
      return null
    }

    const serviceKey = get(state, `myServices.selectedServiceKey`, ``)

    let chatBotCustomerId = ssrWindow.localStorage.getItem(
      localStorageKey.SERVICE_HISTORY_CUSTOMER_ID,
    )

    if (chatBotCustomerId) {
      chatBotCustomerId = chatBotCustomerId.replace(/-/g, "")
    }

    let customerId = chatBotCustomerId || serviceKey.split(" ")[0] || ""

    let serviceId =
      ssrWindow.localStorage.getItem(
        localStorageKey.SERVICE_HISTORY_SERVICE_ID,
      ) ||
      serviceKey.split(" ")[1] ||
      ""

    if (!customerId) return null

    if (!serviceId) {
      const services = get(state, `myServices.services`, [])
      const foundService = find(
        services,
        (item) => item.ezpayId.indexOf(chatBotCustomerId) !== -1,
      )

      if (foundService) {
        serviceId = get(foundService, `services[0].serviceId`, ``)
      }
    }

    while (customerId.length < 15) {
      customerId = `0${customerId}`
    }

    while (serviceId.length < 9) {
      serviceId = `0${serviceId}`
    }

    const url = template.expand({
      userId,
      lang,
      customerId,
      serviceId,
      numOfDays,
    })

    return getTokenAction(dispatch, getState).then((token) => {
      const config = {
        headers: {
          apiKey,
          oktaToken: token.accessToken,
        },
      }

      return axios
        .create(config)
        .get(url)
        .then((response) => {
          const data = get(response, `data.data`, [])

          dispatch(handleFulfilled(data))
          return response
        })
        .catch(() => {
          dispatch(handleFailed(GET_SERVICE_HISTORY_FAILED))
        })
    })
  }
